export default __webpack_public_path__ + "static/arkreen-526c5a0b8cd163d903fc00f34d681984.svg";